import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { platformChatService } from '../../../services/PlatformChatService';
import { chatQueryKeys } from '../chatQueryKeys';

export function usePlatformChatSessionDraftAttachmentsQuery(
  sessionId: string,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const isEnabled =
    (options?.enabled ?? true) && Boolean(user) && sessionId.length > 0;

  return useQuery({
    queryKey: chatQueryKeys.sessionDraftAttachments(sessionId),
    enabled: isEnabled,
    queryFn: () => platformChatService.listSessionDraftAttachments(sessionId),
  });
}
